import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Home, Car } from 'lucide-react';
import { VILLES, villeUrl } from '../../data/villes';

const ZonesIntervention = () => {
  const proches = VILLES.filter((x) => x.km <= 30).slice(0, 24);

  return (
    <section className="py-16 md:py-24 px-4 bg-[#1a2332] text-white" data-testid="zones-intervention-section">
      <div className="max-w-6xl mx-auto">
        <div className="md:flex md:items-end md:justify-between gap-8 mb-10">
          <div>
            <p className="text-blue-400 font-semibold uppercase tracking-wider text-sm mb-3">Zones d'intervention</p>
            <h2 className="text-3xl md:text-4xl font-bold leading-tight">
              Réparateur téléphone à Saint-Chamond, Saint-Étienne et dans toute la Loire (42)
            </h2>
          </div>
          <p className="text-gray-300 mt-4 md:mt-0 md:max-w-sm text-base">
            Atelier à Saint-Chamond et <strong className="text-white">intervention à domicile</strong> dans la vallée du Gier,
            Saint-Étienne Métropole, l'Ondaine, le Pilat et le Forez.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
          <div className="flex items-start gap-3 bg-white/5 rounded-xl p-4">
            <Home className="w-6 h-6 text-green-400 flex-shrink-0 mt-0.5" />
            <div>
              <p className="font-bold">À l'atelier de Saint-Chamond</p>
              <p className="text-gray-300 text-sm">Sur rendez-vous uniquement. Lun.–ven. 10h–18h, sam. 10h–19h. Réparé le jour même.</p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-white/5 rounded-xl p-4">
            <Car className="w-6 h-6 text-blue-400 flex-shrink-0 mt-0.5" />
            <div>
              <p className="font-bold">À votre domicile</p>
              <p className="text-gray-300 text-sm">Nous venons chez vous partout dans la Loire, sur simple appel.</p>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap gap-2">
          {proches.map((ville) => (
            <Link
              key={ville.slug}
              to={villeUrl(ville)}
              data-testid={`zone-link-${ville.slug}`}
              className="inline-flex items-center gap-1.5 px-4 py-2.5 bg-white/10 hover:bg-white hover:text-[#1a2332] rounded-full text-sm font-medium transition-colors"
            >
              <MapPin className="w-3.5 h-3.5" />
              {ville.nom}
            </Link>
          ))}
        </div>

        <div className="mt-8">
          <Link
            to="/zones-intervention"
            data-testid="zones-voir-toutes"
            className="inline-flex items-center gap-2 bg-blue-500 hover:bg-blue-600 text-white px-6 py-3 rounded-xl font-bold transition-colors"
          >
            Voir les {VILLES.length} communes desservies →
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ZonesIntervention;
